import { render, staticRenderFns } from "./PointPaymentSimulation.vue?vue&type=template&id=68917b4e&scoped=true"
import script from "./PointPaymentSimulation.vue?vue&type=script&lang=js"
export * from "./PointPaymentSimulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68917b4e",
  null
  
)

export default component.exports